import axios from 'axios';

import { UserRole } from 'types/models/membership';
import User from 'types/models/user';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

type FetchUsersParams = {
  enterpriseId: number;
  role?: UserRole,
};

async function fetchUsers(params: FetchUsersParams): Promise<APIResponseParsed<User[]>> {
  try {
    const response = await getRequest<User[]>(
      `enterprise/${params.enterpriseId}/users`,
      {
        params: {
          user_role: params.role
        }
      }
    );
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

export default {
  fetchUsers
};